import { cardStyles, FormField, getErrors, Radio } from '@maia/ui';
import { useFieldContext } from '../dynamic-form';
import { ComponentProps, useId } from 'react';
import { RadioGroup } from 'react-aria-components';

type RadioSwitchFieldProps = {
  options: Array<{ label: string; value: string }>;
} & Omit<ComponentProps<typeof FormField>, 'inputSlot'>;

export function RadioSwitchField(props: RadioSwitchFieldProps) {
  const id = useId();
  const { options, ...rest } = props;
  const field = useFieldContext<string>();

  return (
    <FormField
      {...rest}
      error={getErrors(field)}
      inputSlot={
        <RadioGroup
          value={field.state.value}
          onChange={field.handleChange}
          className="flex gap-x-20"
        >
          {options.map((option) => (
            <div
              key={`radio-switch-field-${id}-${option.value}`}
              className={cardStyles({
                variant: 'outlined',
                className: 'p-20 grow',
              })}
            >
              <Radio value={option.value} label={option.label} />
            </div>
          ))}
        </RadioGroup>
      }
    />
  );
}
